var map = {
	"./esports-bg.webp": 1640,
	"./esports-ctg.webp": 1641,
	"./im-img.webp": 1642,
	"./im-title-cn.webp": 1643,
	"./im-title-en.webp": 1644,
	"./object-1.webp": 1645,
	"./object-2.webp": 1646,
	"./object-3.webp": 1647,
	"./object-4.webp": 1648,
	"./tfg-img.webp": 1649,
	"./tfg-title-cn.webp": 1650,
	"./tfg-title-en.webp": 1651,
	"./title-cn.webp": 1652,
	"./title-en.webp": 1653
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1639;